import { useEffect, useRef } from "react";
import type { LibraryItem } from "@/api/models/api-types";
import { getItemUrl, getMediaKind } from "../lib/library-media";
import { useLibraryStore } from "../store/library-store";

const AMBIENT_WIDTH = 48;
const AMBIENT_HEIGHT = 27;

const ambientClass =
  "pointer-events-none absolute inset-0 w-full h-full object-cover scale-125 blur-[80px] saturate-150 opacity-40 dark:opacity-60";

/**
 * Detay ekranının arkasında içeriğin renklerinden oluşan bulanık ambiyans.
 * Videoda ilk kare bir kez küçük bir canvas'a çizilir ve sabit kalır. Canvas
 * yalnızca gösterildiği için (piksel okunmadığı için) CORS'suz videolarda da çalışır.
 */
const VideoAmbient = () => {
  const video = useLibraryStore((state) => state.activeVideoEl);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const context = canvasRef.current?.getContext("2d");
    if (!video || !context) return;

    const drawOnce = () => {
      context.drawImage(video, 0, 0, AMBIENT_WIDTH, AMBIENT_HEIGHT);
    };
    if (video.readyState >= 2) {
      drawOnce();
      return;
    }
    video.addEventListener("loadeddata", drawOnce, { once: true });
    return () => video.removeEventListener("loadeddata", drawOnce);
  }, [video]);

  return (
    <canvas
      ref={canvasRef}
      width={AMBIENT_WIDTH}
      height={AMBIENT_HEIGHT}
      aria-hidden
      className={ambientClass}
    />
  );
};

export const DetailAmbient = ({ item }: { item: LibraryItem }) => {
  const kind = getMediaKind(item);
  if (kind === "image") {
    return <img src={getItemUrl(item)} alt="" aria-hidden className={ambientClass} />;
  }
  if (kind === "video") return <VideoAmbient />;
  return null;
};
